import { ProductTableCountCellView } from './ProductTableCountCellView';

export default ProductTableCountCellView;